// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.consultant_record__trmark[data-v-a186b676] {\n  background: #e3f2fd;\n}\n.consultant_record__trmark[data-v-a186b676]:hover {\n  background-color: rgba(212, 212, 212, 0.3);\n}\n.consultant_record__trmark2[data-v-a186b676] {\n  background: #eeeeee;\n}\n.consultant_record__trmark2[data-v-a186b676]:hover {\n  background-color: rgba(212, 212, 212, 0.3);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
